// removed by extract-text-webpack-plugin
module.exports = {"mainContainer":"src-containers-MessageInput__mainContainer__vAAQQ","child":"src-containers-MessageInput__child__2JWiG"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/MessageInput.css
// module id = 364
// module chunks = 0